import { lprDetectionTypeList } from '../../models';
import callApiAxiosClient from '../../axios/axios_client';

function getDetectionTypes(): Promise<lprDetectionTypeList> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;
  return callApiAxiosClient<lprDetectionTypeList>({
    method: 'get',
    url: 'programmability/get-detection-types',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
  });
}
export default getDetectionTypes;
